export const getCompanyPrefix = (pathname: string) => {
  const firstSegment = pathname?.split("/")[1];

  return ['uae', 'ksa', 'omn'].includes(firstSegment)
    ? firstSegment
    : "uae";
};


const getCompany = (): string => {
  if (typeof window === "undefined") {
    return "uae";
  }

  const company = window.location.pathname.split("/")[1];

  return ['uae', 'ksa', 'omn'].includes(company) ? company : "uae";
};

export const getBaseUrl = () => {
  return `/${getCompany()}/app`;
};